/* CP — menu : rotation du visuel Nike Mind + vignettes crampons de profil.
   Photos verifiees automatiquement (chaussure seule, fond blanc net,
   largeur ~2,2 a 2,8 x la hauteur), meme signature que le rayon incontournables.
   Les rubriques absentes de la liste n'ont aucune photo de profil en mediatheque. */
(function(){
  var F='https://cdn.shopify.com/s/files/1/1043/0142/9084/files/';
  var FIX={
    '/collections/crampons-nike':'o0685.jpg',
    '/collections/crampons-adidas':'o0022.jpg',
    '/collections/crampons-puma':'o0997.jpg',
    '/collections/nike-mercurial-vapor':'o0685.jpg',
    '/collections/nike-mercurial-superfly':'o0640.jpg',
    '/collections/nike-phantom':'o0602.jpg',
    '/collections/nike-tiempo':'o1064.jpg',
    '/collections/nike-hypervenom-retro':'o0464.jpg',
    '/collections/adidas-f50':'o0003.jpg',
    '/collections/adidas-predator':'o0022.jpg',
    '/collections/adidas-copa':'o0002.jpg',
    '/collections/puma-ultra':'o0997.jpg',
    '/collections/mizuno-morelia':'o0606.jpg'
  };
  Object.keys(FIX).forEach(function(h){
    var l=document.querySelectorAll('a[href="'+h+'"] .cst img');
    for(var i=0;i<l.length;i++){ l[i].src=F+FIX[h]+'?width=170'; }
  });

  var w=document.getElementById('amRoll'); if(!w) return;
  var im=w.querySelectorAll('img'); if(im.length<2) return;
  var i=0, t=null;
  function step(){
    im[i].hidden=true;
    i=(i+1)%im.length;
    im[i].hidden=false;
    im[i].style.animation='none'; void im[i].offsetWidth; im[i].style.animation='';
  }
  function on(){ if(!t) t=setInterval(step,1600); }
  function off(){ if(t){ clearInterval(t); t=null; } }
  var ni=w.closest('.ni');
  if(ni){
    ni.addEventListener('mouseenter',on);
    ni.addEventListener('mouseleave',off);
    ni.addEventListener('focusin',on);
    ni.addEventListener('focusout',off);
  } else { on(); }
})();
